import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";
import useIsMobile from "@app.automotus.io/components/hooks/useIsMobile";
import { usePermitApplicationNavigation } from "../../hooks";

export interface PermitApplicationNavigationProps {
  /** Whether the submit action is in progress */
  isSubmitting?: boolean;
  /** Callback when submit button is clicked (only on review step) */
  onSubmit?: () => void;
}

export const PermitApplicationNavigation: React.FC<PermitApplicationNavigationProps> = ({
  isSubmitting = false,
  onSubmit,
}) => {
  const isMobile = useIsMobile();
  const { goNext, goBack, canGoNext, canGoBack, isLastStep, isFirstStep } = usePermitApplicationNavigation();

  const handleNextClick = async () => {
    if (isLastStep && onSubmit) {
      await onSubmit();
    } else if (!isLastStep) {
      goNext();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Button
        variant="outlined"
        onClick={goBack}
        disabled={isFirstStep || !canGoBack || isSubmitting}
        startIcon={<ArrowBackIcon />}
      >
        {isMobile ? null : "Back"}
      </Button>

      {isLastStep ? (
        <Button
          variant="contained"
          onClick={handleNextClick}
          disabled={isLastStep ? false : !canGoNext || isSubmitting}
          endIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <CheckIcon />}
        >
          {isMobile ? "Submit" : "Submit Application"}
        </Button>
      ) : (
        <Button variant="contained" onClick={handleNextClick} disabled={!canGoNext} endIcon={<ArrowForwardIcon />}>
          Next
        </Button>
      )}
    </Box>
  );
};

export default PermitApplicationNavigation;
